import { render, staticRenderFns } from "./ModuleAccessItem.vue?vue&type=template&id=16175a16&scoped=true&"
import script from "./ModuleAccessItem.vue?vue&type=script&lang=js&"
export * from "./ModuleAccessItem.vue?vue&type=script&lang=js&"
import style0 from "./ModuleAccessItem.vue?vue&type=style&index=0&id=16175a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16175a16",
  null
  
)

export default component.exports